import { ArrowLeft } from '@mui/icons-material'
import { Button, Card, CardContent, Divider, Grid, Typography } from '@mui/material'
import { GreenText } from 'components'
import { ClusterShipperDto } from 'dtos'
import { ClusterShipperNeedsClusterDeliveredToThirdPartyConversionCompanyPhotoProps } from '.'
import NeedsClusterDeliveredToThirdPartyConversionCompanyStepper from './NeedsClusterDeliveredToThirdPartyConversionCompanyStepper'
import CheckInReviewItem from 'pages/vehicles/id/checkIn/CheckInReviewItem'

interface Step2ThirdPartyConversionDeliveryReviewProps
  extends ClusterShipperNeedsClusterDeliveredToThirdPartyConversionCompanyPhotoProps {
  onBack: () => void
  onNext: () => void
  clusterShipperDetails: ClusterShipperDto
  clusterShipperGuid?: string
}

export default function Step2CheckInReview({
  onBack,
  onNext,
  clusterShipperDetails,
  clusterShipperGuid,
  thirdPartyConversionDeliveryPhoto,
  setThirdPartyConversionDeliveryPhoto
}: Step2ThirdPartyConversionDeliveryReviewProps) {
  return (
    <Card>
      <CardContent>
        <Grid container spacing={1} alignItems='center'>
          <Grid item xs={12}>
            <NeedsClusterDeliveredToThirdPartyConversionCompanyStepper activeStep={1} />
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>

          <Grid item xs={12} mt={3}>
            <Typography fontWeight='bold' variant='body1'>
              3rd Party Conversion Delivery Photo
            </Typography>
          </Grid>

          <CheckInReviewItem
            complete={Boolean(thirdPartyConversionDeliveryPhoto.clusterShipperThirdPartyConversionDeliveryPhotoFileName)}
            label='3rd Party Conversion Delivery Photo'
          />

          <Grid item xs={12}>
            <GreenText variant='outlined'>
              {`**Needs Cluster Delivered to 3rd Party Conversion Company Steps:**

Displays the current step of the cluster shipper in the Needs Cluster 
Delivered to 3rd Party Conversion Company process.

---

**3rd Party Conversion Delivery Photo Check Mark:**

Displays a check mark to indicate that the 3rd Party Conversion 
Conversion Delivery Photo has been successfully uploaded.

---

**SUBMIT Button:**

Clicking this button will:

Upload the 3rd Party Conversion Delivery Photo and associate it with the 
cluster shipper record, including:

- The name of the user who completed the process.

- A date/time stamp.

Return the user to the Needs Cluster Delivered To 3rd Party Conversion
Company to-do list screen.

---

**PREVIOUS Button:**
Clicking this button will:

- Return the user to the previous step in the process.

---
              `}
            </GreenText>
          </Grid>

          <Grid item xs={12}>
            <Button color='primary' fullWidth onClick={onNext} type='submit' variant='contained'>
              SUBMIT
            </Button>
          </Grid>

          <Grid item xs={12}>
            <Button color='primary' startIcon={<ArrowLeft />} fullWidth onClick={onBack} variant='outlined'>
              PREVIOUS
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
